module.exports = __webpack_public_path__ + "img/29.5ccddf32.jpg";